
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Search } from "lucide-react";
import { LocationNameVerifier } from "./LocationNameVerifier";

export const LocationNameVerificationButton = () => {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm" className="text-blue-600 border-blue-300 hover:bg-blue-50">
          <Search size={16} className="mr-2" />
          Verify Location Names
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-4xl">
        <DialogHeader>
          <DialogTitle>Location Name Database Verification</DialogTitle>
        </DialogHeader>
        <LocationNameVerifier />
      </DialogContent>
    </Dialog>
  );
};
